import { render, staticRenderFns } from "./SiteForm.vue?vue&type=template&id=b4819db4&scoped=true&"
import script from "./SiteForm.vue?vue&type=script&lang=js&"
export * from "./SiteForm.vue?vue&type=script&lang=js&"
import style0 from "./SiteForm.vue?vue&type=style&index=0&id=b4819db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4819db4",
  null
  
)

export default component.exports